import { withAppCrashIfException } from 'epic';
import { fetchLimitOrderAfterTabContentEpic } from 'epic/secondaryMarket/postEventsWorkspace/fetchLimitOrderAfterTabContentEpic';
import { loadLimitOrderToAmendEpic } from 'epic/secondaryMarket/postEventsWorkspace/loadLimitOrderToAmendEpic';
import { persistLimitOrderTabContentEpic } from 'epic/secondaryMarket/postEventsWorkspace/persistLimitOrderTabContentEpic';
import { redirectToOrdersBlotterEpic } from 'epic/secondaryMarket/postEventsWorkspace/redirectToOrdersBlotterEpic';
import { triggerAmendLimitOrderTabContentPersistenceEpic } from 'epic/secondaryMarket/postEventsWorkspace/triggerAmendLimitOrderTabContentPersistenceEpic';
import { combineEpics } from 'redux-observable';

import { clearTabContentEpic } from './clearTabContentEpic';
import { enterWorkspaceEpic } from './enterWorkspaceEpic';
import { fetchCpOrderAfterTabContentEpic } from './fetchCpOrderAfterTabContentEpic';
import { fetchLiveAfterTabContentEpic } from './fetchLiveAfterTabContentEpic';
import { fetchSecondaryPostEventsWorkspaceTabsEpic } from './fetchSecondaryMarketPostEventsWorkspaceTabsEpic';
import { loadCpOrderToAmendEpic } from './loadcpOrderToAmendEpic';
import { loadLiveOrderToAmendEpic } from './loadLiveOrderToAmendEpic';
import { persistCpOrderTabContentEpic } from './persistCpOrderTabContentEpic';
import { persistLiveTabContentEpic } from './persistLiveTabContentEpic';
import { triggerAmendLiveTabContentPersistenceEpic } from './triggerAmendLiveTabContentPersistenceEpic';
import { triggerAmendCpOrderTabContentPersistenceEpic } from './triggerAmendOrderTabContentPersistenceEpic';

export const secondaryMarketPostEventsWorkspaceEpic = () =>
  withAppCrashIfException(
    'secondaryMarketPostEventsWorkspace',
    combineEpics(
      withAppCrashIfException('clearTabContentEpic', clearTabContentEpic()),
      withAppCrashIfException('enterWorkspaceEpic', enterWorkspaceEpic()),
      withAppCrashIfException('fetchSecondaryPostEventsWorkspaceTabsEpic', fetchSecondaryPostEventsWorkspaceTabsEpic()),

      withAppCrashIfException('fetchCpOrderAfterTabContentEpic', fetchCpOrderAfterTabContentEpic()),
      withAppCrashIfException('loadCpOrderToAmendEpic', loadCpOrderToAmendEpic()),
      withAppCrashIfException('persistCpOrderTabContentEpic', persistCpOrderTabContentEpic()),

      withAppCrashIfException('fetchLiveAfterTabContentEpic', fetchLiveAfterTabContentEpic()),
      withAppCrashIfException('loadLiveOrderToAmendEpic', loadLiveOrderToAmendEpic()),
      withAppCrashIfException('persistLiveTabContentEpic', persistLiveTabContentEpic()),

      withAppCrashIfException('fetchLimitOrderAfterTabContentEpic', fetchLimitOrderAfterTabContentEpic()),
      withAppCrashIfException('loadLimitOrderToAmendEpic', loadLimitOrderToAmendEpic()),
      withAppCrashIfException('persistLimitOrderTabContentEpic', persistLimitOrderTabContentEpic()),

      withAppCrashIfException('triggerAmendLiveTabContentPersistenceEpic', triggerAmendLiveTabContentPersistenceEpic()),
      withAppCrashIfException(
        'triggerAmendLimitOrderTabContentPersistenceEpic',
        triggerAmendLimitOrderTabContentPersistenceEpic(),
      ),

      withAppCrashIfException(
        'triggerAmendCpOrderTabContentPersistenceEpic',
        triggerAmendCpOrderTabContentPersistenceEpic(),
      ),
      withAppCrashIfException('redirectToOrdersBlotterEpic', redirectToOrdersBlotterEpic()),
    ),
  );
